// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d752829","553":"7bd3f53e"}[chunkId] + ".chunk.js";
};